<template>
  <div>
    <el-card shadow="never" class="content">
      <div class="view_list">
        <div class="title">
          <div>{{ workshopProjectName }}<span>(数据实时更新)</span></div>
          <div class="search">
            <div>
              单元
              <el-select
                v-model="workshopUnitIds"
                multiple
                placeholder=""
                size="mini"
              >
                <el-option
                  v-for="item in workshopUnit"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              类型
              <el-select
                v-model="workshopProcessTypes"
                multiple
                placeholder=""
                size="mini"
              >
                <el-option
                  v-for="item in workshopProcessType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" size="mini" @click="searchItmes"
              >搜索</el-button
            >
          </div>
        </div>
        <div class="view">
          <el-row style="width: 100%">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <div style="width: 100%">
                <e-charts
                  style="width: 100%"
                  :options="lineOptions"
                  auto-resize
                ></e-charts>
                <div>
                  <p>*说明：进度立柱低于已消耗工时 = 红色（效率低）；进度立柱高于已消耗工时 = 绿色（效率高）；</p>  
               
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <div style="width: 100%">
                <e-charts
                  style="width: 100%"
                  :options="lineOptionsV2"
                  auto-resize
                  :height="height"
                ></e-charts>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import ECharts from "./Charts.vue";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/grid";
import "echarts/lib/component/title";
import "echarts/lib/component/dataZoom";

export default {
  components: { ECharts },
  computed: {},
  props: {
    workshopProjectId: String,
    time: Number,
  },
  watch: {
    time: {
      handler() {
        this.workshopUnitIds = [];
        this.workshopProcessTypes = [];
        this.getWorkshopUnit();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      icon: require("../../../assets/icon.jpg"),
      lineOptions: {
        color: ["#4f82bf", "#92d14f"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: "{b}</br>{a} : {c}%</br>{a1} : {c1}%",
        },
        title: {
          text:
            this.$lange == "en" ? "Project completion status" : "项目完成进度",
          left: "center",
        },
        legend: {
          data: [
            {
              name: this.$lange == "en" ? "Hours spent" : "%已消耗工时",
              icon: "image://https://fosber-pri.oss-cn-shenzhen.aliyuncs.com/LzE2NTc2ODU1OTUzOThpY29uMi5qcGc",
            },
            {
              name: this.$lange == "en" ? "Schedule" : "%进度",
              icon: "image://https://fosber-pri.oss-cn-shenzhen.aliyuncs.com/LzE2NTc2ODM5MjAwNDRpY29uLmpwZw",
            },
          ],

          //       right: "0%",
          // top: "150",
          // orient: "vertical",
          // width: "0%",
          top: "bottom",
        },
        xAxis: {
          type: "category",
          data: [],
          barWidth: 5,
        },
        yAxis: {
          type: "value",
          axisLabel: { formatter: "{value} %" },
        },
        //   grid: {
        //   right: "20%",
        // },
        series: [
          {
            name: this.$lange == "en" ? "Hours spent" : "%已消耗工时",
            data: [],
            type: "bar",
            barWidth: 20,
            label: {
              show: true,
              position: "top",
              formatter: (params) => (params.value ? params.value + "%" : ""),
            },
          },
          {
            name: this.$lange == "en" ? "Schedule" : "%进度",
            data: [],
            type: "bar",
            barWidth: 20,
            label: {
              show: true,
              position: "top",
              formatter: (params) => (params.value ? params.value + "%" : ""),
            },
          },
        ],
      },
      lineOptionsV2: {
        color: ["#92d14f"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: "{b}</br>进度比例: {c}%",
        },
        title: {
          text:
            this.$lange == "en" ? "Phase completion status" : "阶段完成进度",
          left: "center",
        },
        grid: {
          left: "40%",
        },
        xAxis: {
          type: "value",

          axisLabel: { formatter: "{value}" },
        },
        yAxis: {
          type: "category",
          data: [],
          // axisLabel: { formatter: "{value}" },

          // axisLabel: {
          //   formatter: (param) => {
          //     var template = param.toString(); //由于是number类型，所以转字符串
          //     if (template.length > 3) {
          //       // 要显示的字符数
          //       template = template.substring(0, 4) + "..."; //字符串截取
          //     }
          //     return template;
          //   },
          // },
        },
        series: [
          {
            data: [],
            type: "bar",
            barWidth: 20,

            label: {
              show: true,
              position: "right",
              formatter: (params) => (params.value ? params.value + "%" : ""),
            },
          },
        ],
      },
      workshopProjectName: "",
      workshopProcessType: [
        {
          value: "FC101",
          label: "机械类",
        },
        {
          value: "FC104",
          label: "电气类",
        },
        {
          value: "FC108",
          label: "调试类",
        },
      ],
      workshopProcessTypes: [],
      workshopUnit: [],
      workshopUnitIds: [],
      height: "400px",
    };
  },
  methods: {
    saveSeriesData2(e) {
      let percentage = "";
      let schedule = "";
      if (e.percentage) {
        percentage = e.percentage.split("%")[0];
      }
      if (e.schedule) {
        schedule = e.schedule.split("%")[0];
      }
      return {
        value: schedule * 1,
        itemStyle: {
          color: percentage < schedule ? "#92d14f" : "#fe0001",
        },
      };
    },
    saveSeriesData1(e) {
      let percentage = "";
      if (e.percentage) {
        percentage = e.percentage.split("%")[0];
      }
      return percentage * 1;
    },
    saveSeriesData3(e) {
      let completionSchedule = "";
      if (e.completionSchedule) {
        completionSchedule = e.completionSchedule.split("%")[0];
      }
      return completionSchedule * 1;
    },
    getWorkshopUnit() {
      this.ccRequest
        .do(
          "admin/fsb/workshop/unit/query",
          {
            pageNo: 1,
            pageSize: 100000,
            isAsc: false,
            workshopProjectId: this.workshopProjectId,
          },
          "GET"
        )
        .then((res) => {
          let workshopUnit = [];
          for (let index = 0; index < res.rows.length; index++) {
            workshopUnit.push({
              value: res.rows[index].id,
              label: res.rows[index].name,
            });
          }
          this.workshopUnit = workshopUnit;
          this.searchItmes();
        })
        .catch((res) => {
          this.$message({
            type: "danger",
            message: res.response.data.message,
          });
        });
    },
    searchItmes() {
      this.ccRequest
        .do(
          "admin/fsb/workshop/statistics/queryProgressionChartByProjectIds",
          {
            workshopProjectIds: this.workshopProjectId,
            workshopUnitIds: this.workshopUnitIds.join(","),
            workshopProcessTypes: this.workshopProcessTypes.join(","),
          },
          "GET"
        )
        .then((res) => {
          let xAxis = [];
          let seriesData1 = [];
          let seriesData2 = [];
          if (res.length == 0 || res[0].weekStatisticsVoList.length == 0) {
            this.lineOptions.xAxis.data = xAxis;
            this.lineOptions.series[0].data = seriesData1;
            this.lineOptions.series[1].data = seriesData2;
            return false;
          }
          this.workshopProjectName = res[0].workshopProjectName;
          let weekStatisticsVoList = res[0].weekStatisticsVoList;
          for (let index = 0; index < weekStatisticsVoList.length; index++) {
            xAxis.push(weekStatisticsVoList[index].weekNum);
            seriesData1.push(this.saveSeriesData1(weekStatisticsVoList[index]));

            let e = weekStatisticsVoList[index];
            let percentage = "";
            let schedule = "";
            if (e.percentage) {
              percentage = e.percentage.split("%")[0];
            }
            if (e.schedule) {
              schedule = e.schedule.split("%")[0];
            }
            seriesData2.push({
              value: schedule * 1,
              itemStyle: {
                color: percentage * 1 < schedule * 1 ? "#92d14f" : "#fe0001",
              },
            });
            // seriesData2.push(this.saveSeriesData2(weekStatisticsVoList[index]));
          }
          this.lineOptions.xAxis.data = xAxis;
          this.lineOptions.series[0].data = seriesData1;
          this.lineOptions.series[1].data = seriesData2;
        })
        .catch((res) => {
          this.$message({
            type: "danger",
            message: res.response.data.message,
          });
        });

      this.ccRequest
        .do(
          "admin/fsb/workshop/statistics/queryCompletionChartByProjectId",
          {
            workshopProjectIds: this.workshopProjectId,
            workshopUnitIds: this.workshopUnitIds.join(","),
            workshopProcessTypes: this.workshopProcessTypes.join(","),
          },
          "GET"
        )
        .then((res) => {
          let yAxis = [];
          let seriesData1 = [];
          let height = 0;
          if (res.length == 0 || res[0].processStatisticsVoList.length == 0) {
            this.lineOptionsV2.series[0].data = seriesData1;
            return false;
          }

          let processStatisticsVoList = res[0].processStatisticsVoList;

          for (let index = 0; index < processStatisticsVoList.length; index++) {
            // yAxis.push(processStatisticsVoList[index].workshopProcessName.slice(0,4)+'...');
            yAxis.push(processStatisticsVoList[index].workshopProcessName);
            seriesData1.push(
              this.saveSeriesData3(processStatisticsVoList[index])
            );
            height += 40;
          }
          this.lineOptionsV2.yAxis.data = yAxis;
          this.lineOptionsV2.series[0].data = seriesData1;
          this.height = height < 400 ? 400 + "px" : height + "px";
        })
        .catch((res) => {
          this.$message({
            type: "danger",
            message: res.response.data.message,
          });
        });
    },
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
.content {
  margin-top: 10px;
}
.view {
  display: flex;
  margin-top: 20px;
  flex-wrap: wrap;
  width: 100%;
}
.title {
  font-size: 18px;
  font-weight: 700;
  span {
    font-weight: normal;
    font-size: 14px;
  }
  .search {
    font-size: 16px;
    font-weight: normal;
    display: flex;
    align-items: center;
    margin-top: 20px;
    width: 560px;
    justify-content: space-between;
  }
}
  p {
    margin-top: 20px;
    font-size: 12px;
  }
</style>